<template>
  <div class="brands-container" style="overflow-x: auto; white-space: nowrap; margin-bottom:10px;">
    <div v-for="brand in olts" :key="brand.olt_brand_name" class="d-inline-block">
      <div v-if="brand.GPON" class="d-inline-block">
        <span 
          class="badge d-inline-block mr-1 cursor-pointer" 
          :class="{
            'bg-dark': true,
            'border border-2 border-primary': currentOltId === olt.oltid
          }"
          style="min-width: 100px; vertical-align: top;"
          v-for="olt in brand.GPON" 
          :key="`gpon-${olt.oltid}`" 
          @click="$emit('olt-selected', olt.oltid)"
        >
          <div class="olt-name">{{ olt.olt_name }} <span class="badge badge-bg">GPON</span></div>
          <div class="olt-id">ID: {{ olt.oltid }}</div>
          <div v-if="loading && currentLoadingOlt === olt.oltid" class="loading-spinner">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
        </span>
      </div>
      <div v-if="brand.EPON" class="d-inline-block">
        <span 
          class="badge d-inline-block mr-1 cursor-pointer" 
          :class="{
            'bg-dark': true,
            'border border-2 border-primary': currentOltId === olt.oltid
          }"
          style="min-width: 100px; vertical-align: top;"
          v-for="olt in brand.EPON" 
          :key="`epon-${olt.oltid}`"
          @click="$emit('olt-selected', olt.oltid)"
        >
          <div class="olt-name">{{ olt.olt_name }} <span class="badge badge-bg">EPON</span></div>
          <div class="olt-id">ID: {{ olt.oltid }}</div>
          <div v-if="loading && currentLoadingOlt === olt.oltid" class="loading-spinner">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OltSelector",
  props: {
    olts: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    currentLoadingOlt: {
      type: [String, Number],
      default: null
    },
    currentOltId: {
      type: [String, Number],
      default: null
    }
  }
};
</script>

<style scoped>
.olt-name {
  font-weight: bold;
  margin-bottom: 5px;
}

.olt-id {
  color: #b5b4b4;
  font-size: 0.9em;
  margin-bottom: 5px;
}

.loading-spinner {
  margin-top: 5px;
}

.loading-spinner .spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
}

.cursor-pointer {
  cursor: pointer;
}

.badge-bg {
  background-color: #041D3C !important; 
}

/* Add this to ensure the border is visible on the dark background */
.border-primary {
  border-color: #4e73df !important;
}
</style>